// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"5c04e513","874":"60dae9ef"}[chunkId] + ".chunk.js";
};